import { COLORS, RADIUS, fontFamilyFor } from "../../theme";

const fontFor = (isArabic) => fontFamilyFor(isArabic ? "ar" : "en");

export const Style = {
  checkOutModal: {
    width: "100%",
    maxWidth: "520px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "white",
    margin: "25px auto",
    padding: { xs: 0, sm: "0 20px" },
  },
  timerBox: {
    mt: { xs: "60px", md: 0 },
    width: { xs: "calc(100% - 40px)", sm: "100%" },
    borderRadius: RADIUS.card,
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    boxSizing: "border-box",
    padding: "13px 15px",
  },
  timerPara: (isArabic) => ({
    color: COLORS.white,
    textAlign: "center",
    fontFamily: fontFor(isArabic),
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    opacity: "0.7",
  }),
  timerTime: (isArabic) => ({
    color: COLORS.gold,
    fontFamily: fontFor(isArabic),
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
  }),
  divider: {
    color: "rgba(255,255,255,0.1) !important",
    width: "100%",
    margin: "0 !important",
  },
  paymentBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    borderRadius: RADIUS.card,
    marginTop: "20px",
    boxSizing: "border-box",
    background: { xs: "none", sm: "rgba(255,255,255,0.03)" },
    border: { xs: "none", sm: "1px solid rgba(255,255,255,0.08)" },
    padding: { xs: "6px 7px", sm: "16px" },
  },
  paymentHead: (isArabic) => ({
    display: { xs: "none", sm: "flex" },
    justifyContent: isArabic ? "end" : "start",
    color: COLORS.white,
    fontFamily: "'Playfair Display', serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    marginBottom: "15px",
  }),
  paymentChildBox: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "7px 0",
    margin: "10px 0 !important",
  }),
  paymentChildHead: (isArabic) => ({
    color: "rgba(255,255,255,0.55)",
    fontFamily: fontFor(isArabic),
    fontSize: { xs: "14px", sm: "16px" },
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  }),
  paymentChildInfo: (isArabic) => ({
    color: COLORS.white,
    textAlign: "right",
    fontFamily: fontFor(isArabic),
    fontSize: { xs: "14px", sm: "17px" },
    fontStyle: "normal",
    fontWeight: "800",
    lineHeight: "normal",
  }),
  paymentChildTime: (isArabic) => ({
    color: COLORS.white,
    textAlign: "right",
    fontFamily: fontFor(isArabic),
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  }),
  locationBox: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  paymentAmountBox: (isArabic) => ({
    display: "flex",
    height: "fit-content",
    alignItems: "end",
    color: COLORS.white,
    fontFamily: fontFor(isArabic),
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
    gap: "5px",
  }),
  paymentAmount: (isArabic) => ({
    color: COLORS.gold,
    fontFamily: fontFor(isArabic),
    fontSize: { xs: "16px", sm: "22px" },
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  }),
  discount: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  }),
  discountButton: (isArabic) => ({
    color: COLORS.dark,
    textAlign: "center",
    fontFamily: fontFor(isArabic),
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    height: "55px",
    flexShrink: "0",
    borderRadius: RADIUS.input,
    background: COLORS.peach,
    boxShadow: "none",
    marginLeft: isArabic ? 0 : "10px",
    marginRight: isArabic ? "10px" : 0,
    "&:hover": { background: COLORS.gold },
  }),
  discountInput: (isArabic) => ({
    color: COLORS.white,
    background: "rgba(255,255,255,0.05)",
    width: "100%",
    borderRadius: RADIUS.input,
    border: "1px solid rgba(255,255,255,0.12)",
    height: "55px",
    borderBottom: "none !important",
    "& .MuiOutlinedInput-input": {
      textAlign: isArabic ? "end" : "start",
      fontFamily: fontFor(isArabic),
    },
    "&::placeholder": {
      color: COLORS.white,
    },
    "& #input-with-icon-adornment": {
      textAlign: isArabic ? "end" : "start",
      padding: "10px",
    },
    "&::before": {
      borderBottom: "none !important",
    },
    "&::after": {
      borderBottom: "none !important",
    },
  }),
  discountInputLabel: {
    color: COLORS.white,
  },
  discountMessage: () => ({
    color: "#ff6b6b",
  }),
  selectOrangeBox: (isArabic) => ({
    border: `2px solid ${COLORS.gold}`,
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    borderRadius: RADIUS.input,
    padding: "15px 26px",
    background: "rgba(212,175,55,0.08)",
    margin: "12px 0",
    cursor: "pointer",
  }),
  selectOrangeBoxFlex: (isArabic) => ({
    border: `2px solid ${COLORS.gold}`,
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    borderRadius: RADIUS.input,
    padding: "15px 26px",
    background: "rgba(212,175,55,0.08)",
    margin: "12px 0",
    cursor: "pointer",
  }),
  selectGrayBox: (isArabic) => ({
    cursor: "pointer",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "calc( 100% - 2px )",
    boxSizing: "border-box",
    borderRadius: RADIUS.input,
    padding: "17px 25px",
    margin: "12px 0",
  }),
  Heading: (isArabic) => ({
    color: COLORS.white,
    fontFamily: "'Playfair Display', serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    display: "flex",
    width: "100%",
    justifyContent: isArabic ? "end" : "start",
    margin: { xs: "35px 0 15px", sm: "25px 0 15px !important" },
  }),
  grayBox: {
    width: "100%",
    borderRadius: RADIUS.card,
    background: { sm: "none", xs: "rgba(255,255,255,0.04)" },
    boxShadow: "none",
    boxSizing: "border-box",
    padding: "0 15px",
  },
  flex: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    gap: "8px",
    color: COLORS.white,
  }),
  orangeIcon: {
    fontSize: "40px",
    fill: COLORS.gold,
  },
  grayIcon: {
    fontSize: "40px",
    fill: "rgba(255,255,255,0.2)",
  },
  selectBox: (isArabic) => ({
    textAlign: isArabic ? "end" : "start",
    width: "100%",
  }),
  input: (isArabic) => ({
    color: COLORS.white,
    background: "rgba(255,255,255,0.05)",
    width: "100%",
    borderRadius: RADIUS.input,
    "& .MuiOutlinedInput-input": {
      textAlign: isArabic ? "end" : "start",
      fontFamily: fontFor(isArabic),
    },
  }),
  confirm: (isArabic) => ({
    color: "rgba(255,255,255,0.55)",
    fontFamily: fontFor(isArabic),
    marginTop: "22px",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  }),
  terms: (isArabic) => ({
    color: COLORS.gold,
    fontFamily: fontFor(isArabic),
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
    margin: "3px 0",
  }),
  confirmButton: (isArabic) => ({
    color: `${COLORS.dark} !important`,
    textAlign: "center",
    fontFamily: fontFor(isArabic),
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    marginTop: "18px",
    height: "56px",
    flexShrink: "0",
    borderRadius: RADIUS.pill,
    background: COLORS.peach,
    boxShadow: "none",
    width: "100%",
    "&:hover": { background: COLORS.gold },
  }),
  checkOutHeading: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    letterSpacing: "0.00938em",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  }),
};
